export interface InviteNewUsersToCompanyFormData {
  emails: string[];
}

export const enum InviteNewUsersToCompanyFormFields {
  EMAILS = 'emails'
}
